import "slick-carousel";
/**============================================================
*   [article image slider]
*   description : 販売画像スライド処理を記述
============================================================*/
class articleImageSlider {
  constructor(elem){
    this.$el = elem;
  }
  setSlider(){
    $(this.$el).slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      // adaptiveHeight: true,
      prevArrow: $(this.$el).nextAll('.js-article__image__slider-prev'),
      nextArrow: $(this.$el).nextAll('.js-article__image__slider-next'),
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
      ]
    });
  }
}
export default articleImageSlider;

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js-article__image__slider').forEach((el, index) => {
    var imgSlider = new articleImageSlider(el);
    imgSlider.setSlider();
  })
});
